import { createAction, props } from '@ngrx/store';
import { Sector } from '../../models/sector';

export const loadSectors = createAction('[Sector/API] Load Sectors ', props<{ organizationId: string }>());
export const loadSectorsSuccess = createAction('[Sector/API] Load Sectors success', props<{ sectors: Sector[] }>());
export const loadSectorsFailure = createAction('[Sector/API] Load Sectors failure', props<{ error: any }>());
